// extracted by mini-css-extract-plugin
export default {"cls1":"y3rlgAPr_xwZXauRGO9N","cls2":"Pk9ZA6gFYPcRIUe9tOgz y3rlgAPr_xwZXauRGO9N"};